import "./Homescreen/Login.css";
import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import NavbarLogin from "./NavbarLogin";
import emailjs from "@emailjs/browser";

function Login() {
  const form = useRef();

  const options = [
    { label: "English", value: "English" },
    { label: "Tamil", value: "Tamil" },
    { label: "Hindi", value: "Hindi" },
    { label: "Maths", value: "Maths" },
    { label: "Vedic Math", value: "Vedic Math" },
    { label: "Physics", value: "Physics" },
    { label: "Chemistry", value: "Chemistry" },
    { label: "Biology", value: "Biology" },
    { label: "Science", value: "Science" },
    { label: "Social Studies", value: "Social Studies" },
    { label: "Computer science", value: "Computer science" },
    {
      label: "Career counselling for grade 10 - 12 Students",
      value: "Career counselling for grade 10 - 12 Students",
    },
    { label: "Other", value: "Other" },
  ];
  const board = [
    { label: "CBSE", value: "CBSE" },
    { label: "IGCSE", value: "IGCSE" },
    { label: "IB", value: "IB" },
    { label: "State Board", value: "State Board" },
    { label: "NIOS", value: "NIOS" },
    { label: "Other", value: "Other" },
  ];
  const grade = [
    { label: "Grade 1- Grade 5", value: "Grade 1- Grade 5" },
    { label: "Grade 6 - Grade 8", value: "Grade 6 - Grade 8" },
    { label: "Grade 9 & 10", value: "Grade 9 & 10" },
    { label: "Grade 11& 12", value: "Grade 11& 12" },
    { label: "Competitive exams - NEET", value: "Competitive exams - NEET" },
    { label: "Competitive exams - IIT - JEE", value: "Competitive exams - IIT - JEE" },
    { label: "Other", value: "Other" },
  ];
  const sgrade = Array.from({ length: 12 }, (_, i) => ({ label: `Grade ${i+1}`, value: `Grade ${i+1}` }))
    .concat([
      { label: "Competitive exams - NEET", value: "Competitive exams - NEET" },
      { label: "Competitive exams - IIT - JEE", value: "Competitive exams - IIT - JEE" },
      { label: "Other", value: "Other" },
    ]);
  const country = [
    { label: "Australia", value: "Australia" },
    { label: "Canada", value: "Canada" },
    { label: "Denmark", value: "Denmark" },
    { label: "France", value: "France" },
    { label: "Finland", value: "Finland" },
    { label: "Germany", value: "Germany" },
    { label: "Greenland", value: "Greenland" },
    { label: "Hong Kong", value: "Hong Kong" },
    { label: "India", value: "India" },
    { label: "Italy", value: "Italy" },
    { label: "Japan", value: "Japan" },
    { label: "Malaysia", value: "Malaysia" },
    { label: "Mexico", value: "Mexico" },
    { label: "Newzealand", value: "Newzealand" },
    { label: "Norway", value: "Norway" },
    { label: "Poland", value: "Poland" },
    { label: "Singapore", value: "Singapore" },
    { label: "South Africa", value: "South Africa" },
    { label: "Srilanka", value: "Srilanka" },
    { label: "Switzerland", value: "Switzerland" },
    { label: "UAE", value: "UAE" },
    { label: "United Kingdom", value: "United Kingdom" },
    { label: "United States", value: "United States" },
    { label: "Other", value: "Other" },
  ];
  const timeSlots = [
    "5am - 6am",
    "6am - 7am",
    "7am - 8am",
    "8am - 9am",
    "9am - 10am",
    "10am - 11am",
    "11am - 12pm",
    "12pm - 1pm",
    "1pm - 2pm",
    "2pm - 3pm",
    "3pm - 4pm",
    "4pm - 5pm",
    "5pm - 6pm",
    "6pm - 7pm",
    "7pm - 8pm",
    "8pm - 9pm",
    "9pm - 10pm",
    "10pm - 11pm",
    "NA",
  ].map(slot => ({ label: slot, value: slot }));
  
  const [selected, setSelected] = useState([]);
  const [cselected, csetSelected] = useState([]);
  const [bselected, setboardSelected] = useState([]);
  const [gselected, setgradeSelected] = useState([]);
  const [sgselected, setsgradeSelected] = useState([]);
  const [gender, setGender] = useState("");
  const [userType, setUserType] = useState("");
  const [availabilityState, setAvailabilityState] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate Subjects (common)
    if (selected.length === 0) {
      alert("Please select your subject.");
      return;
    }

    // Validate country
    if (cselected.length === 0) {
      alert("Please select your country.");
      return;
    }

    // Student validation
    if (userType === "Student") {

      if (bselected.length === 0) {
        alert("Please select your board.");
        return;
      }

      if (sgselected.length === 0) {
        alert("Please select your grade.");
        return;
      }
    }

    // Tutor validation
    if (userType === "Tutor") {

      if (gselected.length === 0) {
        alert("Please select grade you teach.");
        return;
      }

      if (bselected.length === 0) {
        alert("Please select board you teach.");
        return;
      }
    }
    if (!window.confirm("Please check your details once before registration"))
      return;
    // After validation, continue form submit
    const availability = {};
    Object.keys(availabilityState).forEach(day => {
    availability[day] = (availabilityState[day] || []).map(slot => slot.value);
    });

    const formData = {
      first_name: e.target.first_name.value,
      last_name: e.target.last_name.value,
      email: e.target.email.value,
      number: e.target.number.value,
      whatsapp_number: e.target.whatsapp_number.value,
      address: e.target.address?.value || "",
      gender,
      usertype: userType,
      subjects: selected.map((s) => s.value).join(","),
      country: cselected?.value || "",

      // Student-specific
      grade: sgselected.map((sg) => sg.value).join(","),
      board: bselected.map((b) => b.value).join(","),
      school: e.target.school?.value || "",
      parent_name: e.target.parent_name?.value || "",
      parent_number: e.target.parent_number?.value || "",
      parent_email: e.target.parent_email?.value || "",
      parent_job: e.target.parent_job?.value || "",

      // Tutor-specific
      tgrade: gselected.map((g) => g.value).join(","),
      tboard: bselected.map((tb) => tb.value).join(","),
      qualification: e.target.qualification?.value || "",
      additional_qualification: e.target.additional_qualification?.value || "",
      languages: e.target.languages?.value || "",
      experience: e.target.experience?.value || "",
      // Availability
      availability: JSON.stringify(availability),
    };

    try {
      //const response = await fetch("http://localhost:8000/api/register",
      const response = await fetch("https://alphabeta4success.com/api/register",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(formData),
        }
      );
      const data = await response.json();
      if (data.success) {
      alert("Registered successfully!");
      //sending confirm Email
      await emailjs.sendForm(
         "service_cqwf1jr",
         "template_9vp1hhd",
         form.current,
         "RLVptYs1LmXuoikCr"
       );
       alert("Email successfully sent to AB4S Team.!");
       // Clear form inputs
       form.current.reset();
       //Reset React state
       setGender('');
       setUserType('');
       setSelected('');
       csetSelected('');
       setboardSelected('');
       setgradeSelected('');
       setsgradeSelected('');
       setAvailabilityState({});
     } else {
       alert("Registration failed: " + data.error);
       return;
     }
    } catch (err) {
      console.error(err);
      alert("An error occurred during registration. Please contact AB4S Team.");
    }
  };

  return (
    <>
      <NavbarLogin />
      <div className="form_wrapper">
        <div className="form_container">
          <form ref={form} onSubmit={handleSubmit}>
            <div className="title_container">
              <h2>Registration Form</h2>
            </div>

            {/* Main form grid */}
            <div className="form-grid">
              {/* Left column */}
              <div>
                <div className="input_field">
                  <input
                    type="text"
                    name="first_name"
                    placeholder="First Name"
                    required
                  />
                </div>
                <div className="input_field">
                  <input type="email" name="email" placeholder="Email" required />
                </div>
                <div>
                <input className="input_field"
                    type="text"
                    name="number"
                    placeholder="Mobile Number with country code"
                    required
                  />
                </div>

                <div className="col_half">
                    <label><strong>Gender</strong></label>
                </div>
                <div className="input_field">
                    <div className="input_field radio_option">              
                    <input type="radio" name="gender" value="Male" id="gender1" onChange={e=>setGender(e.target.value)} required/>
                    <label for="gender1">Male</label>
                    <input type="radio" name="gender" value="Female" id="gender2" onChange={e=>setGender(e.target.value)} required/>          
                    <label for="gender2">Female</label>
                    </div>
                </div>
                           
                <div className="input_field select_option">
                  <Select
                    id="country"
                    name="country"
                    options={country}
                    value={cselected}
                    placeholder="Select Country"
                    onChange={csetSelected}
                    required
                  />
                  <input
                    type="hidden"
                    name="country"
                    value={cselected?.value || ""}
                  />
                </div>
              </div>

              {/* Right column */}
              <div>
                <div className="input_field">
                  <input
                    type="text"
                    name="last_name"
                    placeholder="Last Name"
                    required
                  />
                </div>
                <div className="input_field">
                    <input
                      type="text"
                      name="address"
                      placeholder="Address"
                      required
                    />
                </div>
                <div className="input_field">
                  <input
                    type="text"
                    name="whatsapp_number"
                    placeholder="Whatsapp Number with country code"
                    required
                  />
                </div>
                <div className="col_half">
                    <label><strong>User Type</strong></label>
                </div>
                <div className="input_field">
                    <div className="input_field radio_option">              
                    <input type="radio" value="Tutor" name="usertype" id="rd1" onChange={(e) => setUserType(e.target.value)} required/>
                    <label for="rd1">Tutor</label>
                    <input type="radio" value="Student" name="usertype" onChange={(e) => setUserType(e.target.value)} id="rd2" required/>
                    <label for="rd2">Student</label>
                    </div>
                </div>
                <div className="input_field select_option full-width">
                <Select
                    id="subject"
                    name="subject"
                    options={options}
                    value={selected}        
                    onChange={setSelected}
                    placeholder="Select Subjects"
                    isMulti={true}
                    required
                />
                <input
                    type="hidden"
                    name="subjects"
                    value={selected?.value || ""}
                />
                </div>
              </div>
            </div>
            {/* Student-specific fields */}
            {userType === "Student" && (
              <div className="form-grid full-width">
                {/* Left column */}
                <div>
                <div className="input_field select_option">
                  <Select
                    id="board"
                    name="board"
                    options={board}
                    value={bselected}
                    isMulti={true}
                    placeholder="Select Board"
                    onChange={setboardSelected}
                    required
                  />
                  <input
                    type="hidden"
                    name="board"
                    value={bselected?.value || ""}
                  />
                  </div>
                  <div className="input_field">
                    <input type="text" name="school" placeholder="School" required />
                  </div>    
                  <div className="input_field">
                    <input type="text" name="parent_job" placeholder="Parent/Guardian's Occupation" required />
                  </div>
                  <div className="input_field">
                    <input type="text" name="parent_number" placeholder="Parent/Guardian's Phone Number" required />
                  </div>
                </div>
                {/* right column */}
                <div>
                  <div className="input_field select_option">
                    <Select
                        id="sgrade"
                        name="sgrade"
                        options={sgrade}
                        value={sgselected}
                        isMulti={true}
                        placeholder="Select Grade"
                        onChange={setsgradeSelected}
                        required
                    />
                    <input
                        type="hidden"
                        name="sgrade"
                        value={sgselected?.value || ""}
                    />
                  </div>
                  <div className="input_field">
                    <input type="text" name="parent_name" placeholder="Parent/Guardian's Name" required />
                  </div>
                <div className="input_field">
                    <input type="text" name="parent_email" placeholder="Parent/Guardian's EmailID" required />
                  </div>
              </div>
              </div>
            )}

            {/* Tutor-specific fields */}
            {userType === "Tutor" && (
              <div className="full-width">
                <div className="form-grid">
                  {/* Left column */}
                  <div>
                   <div className="input_field select_option">
                    <Select
                        id="grade"
                        name="grade"
                        options={grade}
                        value={gselected}
                        isMulti={true}
                        placeholder="Select Grade you teach"
                        onChange={setgradeSelected}
                        required
                    />
                    <input
                        type="hidden"
                        name="tgrade"
                        value={gselected?.value || ""}
                    />
                    </div>
                    <div className="input_field">
                      <input
                        type="text"
                        name="qualification"
                        placeholder="Qualification"
                        required
                      />
                    </div>
                    <div className="input_field">
                      <input
                        type="number"
                        name="experience"
                        placeholder="Teaching Experience (in years)"
                        required
                      />
                    </div>
                  </div>
                  {/* Right column */}
                  <div>
                  <div className="input_field select_option">
                    <Select
                        id="curriculum"
                        name="curriculum"
                        options={board}
                        value={bselected}
                        isMulti={true}
                        placeholder="Select Board you are aware of"
                        onChange={setboardSelected}
                        required
                    />
                    <input
                        type="hidden"
                        name="tboard"
                        value={bselected?.value || ""}
                    />
                    </div>
                    <div className="input_field">
                      <input
                        type="text"
                        name="additional_qualification"
                        placeholder="Additional Qualification"
                      />
                    </div>
                    <div className="input_field">
                      <input
                        type="text"
                        name="languages"
                        placeholder="Languages Known"
                        required
                      />
                    </div>
                  </div>
                </div>
              </div>
            )}

            {/* Availability */}
            <div className="input_field full-width">
            <label><strong>User's Availability (Weekly):</strong></label>
            <div className="availability-weekly">
                {["Monday","Tuesday","Wednesday","Thursday","Friday","Saturday","Sunday"].map(day => (
                <div key={day} className="availability-day">
                    <strong>{day}</strong>
                    <Select
                    isMulti
                    options={timeSlots}
                    value={availabilityState[day] || []}
                    onChange={selectedOptions => 
                        setAvailabilityState(prev => ({ ...prev, [day]: selectedOptions }))
                    }
                    placeholder="Select time slots"
                    />
                </div>
                ))}
            </div>
            </div>
            {/* Terms + Submit */}
            <div className="input_field checkbox_option full-width">
              <input type="checkbox" id="cb1" required />
              <label htmlFor="cb1">I agree with terms and conditions</label>
            </div>
            <div className="input_field full-width">
              <input className="button" type="submit" value="Register" />
              <h2 align="center" className="or">
                OR
              </h2>
              <h2><p align="center">
                Already have an account ? <Link to="/Signin"> Login </Link>
              </p></h2>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}

export default Login;
